"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var Recipe_1 = require("../model/Recipe");

var IngredientConverter_1 = require("./IngredientConverter");

var RecipeConverter_1 = require("./RecipeConverter");
/**
 * Implementation of {@link RecipeConverter}
 *
 * @author Adam Drda
 */


var RecipeConverterImpl =
/*#__PURE__*/
function (_RecipeConverter_1$Re) {
  _inherits(RecipeConverterImpl, _RecipeConverter_1$Re);

  function RecipeConverterImpl(ingredientConverter) {
    var _this;

    _classCallCheck(this, RecipeConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RecipeConverterImpl).call(this));
    _this.ingredientConverter = ingredientConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(RecipeConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new Recipe_1.Recipe(Recipe_1.Recipe.schema.id.valueOf(conversions.documentToClassId(source)), Recipe_1.Recipe.schema.externalId.valueOfField(source), Recipe_1.Recipe.schema.productId.valueOfField(source), Recipe_1.Recipe.schema.amountToMake.valueOfField(source), conversions.asObjectList(source, 'ingredients', function (object) {
        return _this2.ingredientConverter.toObject(object, conversions);
      }));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        externalId: source.externalId,
        productId: source.productId,
        amountToMake: source.amountToMake
      });
      Object.assign(result, {
        ingredients: conversions.asObjectArray(source, 'ingredients', function (object) {
          return _this3.ingredientConverter.toDocument(object, conversions);
        })
      });
      return result;
    }
  }]);

  return RecipeConverterImpl;
}(RecipeConverter_1.RecipeConverter);

RecipeConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [IngredientConverter_1.IngredientConverter])], RecipeConverterImpl);
exports.RecipeConverterImpl = RecipeConverterImpl;